<template>
  <!-- 火车票城市组件 -->
  <div v-checkoutside="handleClose" class="tt-rlt">
    <el-input
      v-model="value"
      class="cityInput"
      placeholder="中文/拼音/简拼输入"
      :type="$attrs.type"
      @focus="selectCity"
      @input="filterCity"
    />
    <div v-show="cityBoxShow" :style="style" class="cityBox">
      <p class="cityBox-header">
        请选择城市或输入城市名称的拼音或英文
        <i
          class="iconfont tt-fr"
          style="cursor: pointer;margin-right: 10px;"
          @click="hideCityBox()"
        >&#xe65e;</i>
      </p>
      <div class="cityInner">
        <ul class="cityBoxTabs clearFix">
          <li :class="{ active: 'hot' === activeIndex }" @click="changeCode('hot')">热门</li>
          <li
            v-for="(city, idx) in cityCode"
            :key="city.id"
            :class="{ active: idx === activeIndex }"
            @click="changeCode(idx, city)"
          >{{ city }}</li>
        </ul>
        <div v-for="(item, key) in cityList"  :class="activeIndex" :key="item.index" class="cityBoxContainer clearFix">
          <div v-if="key !== 'hot'" class="title clearFix tt-fl">{{ key }}</div>
          <ul class="tt-fl">
            <li v-for="city in item" :key="city.index" @click="checkCity(city)">
              <template>{{ city.name }}</template>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div v-show="searchBoxShow" :style="style" class="searchBox">
      <i
        class="iconfont tt-fr"
        style="cursor: pointer;color:#999;"
        @click="hideSearchBox()"
      >&#xe65e;</i>
      <ul>
        <li v-for="val in dataList" :key="val.index" @click="checkCity(val)">
          <el-tag type="success" effect="dark">
            <slot>火车站</slot>
          </el-tag>
          {{ val.name }} ({{ val.spell }})
        </li>
        <li v-if="dataList.length == 0">非常抱歉，暂时还没有此地点</li>
      </ul>
    </div>
  </div>
</template>
<script>
import checkoutside from '@utils/checkoutside'
import { trainCity } from './trainCityData'
export default {
  name: 'trainCity',
  data () {
    return {
      value: '',
      cityBoxShow: false,
      searchBoxShow: false,
      activeIndex: 'hot',
      style: {},
      cityCodeObj: {},
      cityCode: {},
      cityList: {},
      dataList: [],
      originalData: []
    }
  },
  directives: { checkoutside },
  updated () {
    this.value = this.$attrs.value
  },
  created () {
    this.value = this.$attrs.value
    this.originalData = this.$copy(trainCity)
    this.renderData()
  },
  methods: {
    renderData () {
      this.originalData = this.originalData.sort((a, b) => {
        if (a.spell.charAt(0).toUpperCase() > b.spell.charAt(0).toUpperCase()) {
          return 1
        } else if (
          a.spell.charAt(0).toUpperCase() < b.spell.charAt(0).toUpperCase()
        ) {
          return -1
        } else {
          return 0
        }
      })
      this.originalData.forEach(item => {
        const charCode = item.spell.charAt(0).toUpperCase()
        if (this.cityCodeObj.hasOwnProperty(charCode)) {
          this.cityCodeObj[charCode].push(item)
        } else {
          this.cityCodeObj[charCode] = [item]
        }
      })
      this.cityCode = Object.keys(this.cityCodeObj)
        .join('')
        .match(/\w{1,4}/g)
      this.cityList['hot'] = this.originalData.filter(item => item.isHot)
    },
    // 关闭城市选择弹框
    handleClose () {
      this.cityBoxShow = false
      this.searchBoxShow = false
    },
    // 显示城市选择弹框
    selectCity () {
      const point = event.target.getBoundingClientRect()
      this.style = this.$attrs.customStyle || {
        top: point.height + 1 + 'px'
      }
      if (this.searchBoxShow && this.value.replace(/\s/g, '')) {
        return
      }
      this.cityBoxShow = true
    },
    // 检索城市
    filterCity () {
      var keyword = this.value.replace(/\s/g, '').toUpperCase()
      this.$emit('input', this.value)
      this.dataList = []
      this.cityBoxShow = false
      this.searchBoxShow = true
      if (keyword.length === 0) {
        this.cityBoxShow = true
        this.searchBoxShow = false
      }
      const searchList = this.originalData.filter(item => {
        if (/[a-zA-Z]/.test(keyword)) {
          return (
            item.spellShort.toUpperCase().match(keyword) ||
            item.spell.toUpperCase().match(keyword)
          )
        } else {
          return item.name.match(keyword)
        }
      })
      this.dataList = searchList
    },
    // 切换城市首字母
    changeCode (idx, cityCode) {
      this.activeIndex = idx
      this.cityList = {}
      if (idx === 'hot') {
        this.cityList['hot'] = this.originalData.filter(item => item.isHot)
        return
      }
      this.cityCodeList = cityCode.match(/\w{1}/g)
      this.cityCodeList.forEach(item => {
        if (this.cityCodeObj.hasOwnProperty(item)) {
          this.cityList[item] = this.cityCodeObj[item]
        }
      })
    },
    // 点击关闭城市选择弹框
    hideCityBox () {
      this.cityBoxShow = false
    },
    // 点击选择城市
    checkCity (item) {
      this.cityBoxShow = false
      this.searchBoxShow = false
      this.value = item.name
      this.$emit('input', this.value)
    },
    // 点击关闭搜索城市选择弹框
    hideSearchBox () {
      this.searchBoxShow = false
    }
  }
}
</script>

<style lang="less">
.cityInput input {
  text-transform: uppercase;
}
</style>
<style lang="less" scoped>
.cityBox {
  position: absolute;
  width: 600px;
  left: 0;
  top: 0;
  font-size: 12px;
  background-color: #fff;
  -moz-box-shadow: 0.966px 0.259px 6px 0 rgba(53, 53, 53, 0.2);
  -webkit-box-shadow: 0.966px 0.259px 6px 0 rgba(53, 53, 53, 0.2);
  box-shadow: 0.966px 0.259px 6px 0 rgba(53, 53, 53, 0.2);
  border: 1px solid #98a1b3;
  font-family: arial, SimSun, Verdana, Geneva, Helvetica;
  z-index: 9999;
  padding-bottom: 8px;
  border-radius: 10px;
}
.cityBox-header {
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
  color: #999;
}
.cityBoxTabs li {
  float: left;
  color: #006eff;
  padding: 0 9px;
  height: 26px;
  line-height: 26px;
  cursor: pointer;
}
.cityBoxTabs li.active {
  color: #fff;
  padding: 0 8px;
  font-weight: 700;
  background-color: #006eff;
  border-radius: 3px 3px 0 0;
}
.cityBoxTabs {
  border-bottom: 1px #d7d7d7 solid;
}
.cityBoxTabs .titile {
  font-size: 16px;
  color: #333;
  padding: 0 9px;
}
.cityBoxContainer {
  padding-top: 5px;
  max-height: 50px;
  overflow: hidden;
  display: flex;
  &.hot{
    max-height: 170px;
  }
}
.cityBoxContainer .title {
  color: #006eff;
  padding: 0 5px;
  position: relative;
  left: 6px;
  margin: 0;
}
.cityBoxContainer ul {
  padding-left: 26px;
}
.cityBoxContainer ul li {
  float: left;
  width: 100px;
  margin-right: 10px;
  height: 24px;
  line-height: 24px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
  padding: 0 2px;
}
.cityBoxContainer ul li:hover {
  color: #fff;
  background-color: #006eff;
}
.searchBox {
  width: 360px;
  position: absolute;
  left: 0;
  top: 0;
  word-spacing: 0;
  font-size: 12px;
  background-color: #fff;
  -webkit-box-shadow: 0.966px 0.259px 6px 0 rgba(53, 53, 53, 0.2);
  box-shadow: 0.966px 0.259px 6px 0 rgba(53, 53, 53, 0.2);
  border: 1px solid #98a1b3;
  font-family: arial, SimSun, Verdana, Geneva, Helvetica;
  z-index: 120;
  border-radius: 10px;
  padding: 10px;
  max-height: 330px;
  overflow: hidden;
}
.searchBox ul li {
  margin-bottom: 10px;
  cursor: pointer;
}
.searchBox ul li:hover {
  // background-color: #006eff;
  color: #006eff;
  font-size: 12px;
  font-weight: bold;
}
.el-tag {
  width: 54px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/TrainCityBox.vue